import { lazy, Suspense } from 'react'
import { LoadingState } from '@/src/components/LoadingState'
import { AuthGate } from '@/src/shell/AuthGate'

// three.js is heavy: it loads only when someone opens the terminal.
const TerminalPage = lazy(() =>
  import('./TerminalPage').then((module) => ({ default: module.TerminalPage })),
)

/** The 3D terminal, full screen and outside the app shell, for signed-in Helm users. */
export function TerminalRoute() {
  return (
    <AuthGate>
      {() => (
        <Suspense fallback={<LoadingState label="Opening the terminal..." />}>
          <TerminalPage />
        </Suspense>
      )}
    </AuthGate>
  )
}
